import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { extendTailwindMerge } from 'tailwind-merge';
import { Icon } from '../../../icon/src';
const twMerge = extendTailwindMerge({
    prefix: 'nucleus-',
});
const badgeVariantColors = {
    common: 'nucleus-bg-gray-100 nucleus-border-gray-200 nucleus-text-text-primary',
    incomplete: 'nucleus-bg-yellow-100 nucleus-border-yellow-200 nucleus-text-yellow-900',
    success: 'nucleus-bg-green-100 nucleus-border-green-200 nucleus-text-green-900',
    danger: 'nucleus-bg-red-100 nucleus-border-red-200 nucleus-text-text-error',
    active: 'nucleus-bg-blue-100 nucleus-border-blue-200 nucleus-text-blue-950',
    new: 'nucleus-bg-primary-75 nucleus-border-primary-200 nucleus-text-primary-950',
    warning: 'nucleus-bg-orange-100 nucleus-border-orange-200 nucleus-text-orange-900',
};
/**
 * Badges are used to show differences in objects, item counts, or system status.
 */
export const Badge = (_a) => {
    var { dataTestId, variant = 'common', className, label, startIcon, endIcon } = _a, props = __rest(_a, ["dataTestId", "variant", "className", "label", "startIcon", "endIcon"]);
    return (_jsxs("div", Object.assign({ "data-testid": dataTestId, className: twMerge(`nucleus-box-border nucleus-font-sans nucleus-inline-flex nucleus-w-fit nucleus-gap-1 nucleus-items-center nucleus-rounded-md nucleus-px-2 nucleus-py-1 nucleus-text-xs nucleus-font-medium nucleus-border nucleus-border-solid ${badgeVariantColors[variant]}`, className) }, props, { role: 'status', "aria-label": label, children: [startIcon && _jsx(Icon, Object.assign({ color: 'current' }, startIcon)), _jsx("span", { children: label }), endIcon && _jsx(Icon, Object.assign({ color: 'current' }, endIcon))] })));
};
//# sourceMappingURL=badge.js.map